import { Store } from '@ngxs/store';
import _ from 'lodash';
import { DirectoryEntryRemoteDto } from 'src/generated/swagger';
import { DirectoryColumn } from '../samwebDescription/samweb/directory/directory-column';
import { DirectoryStructureSelectors } from '../store/samwin/directory/directory-structure/directory-structure.selectors';

export function getEntryValueForColumn(store: Store, entry: DirectoryEntryRemoteDto, column: DirectoryColumn) {
   if (_.isNil(entry)) {
      return null;
   }

   const entryValue = store.selectSnapshot(DirectoryStructureSelectors.getColumnInstance)(entry, column);
   if (entryValue?.isValueSet) {
      return entryValue.value.toString();
   }
   return '';
}
